import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import LandingHeader from './components/LandingHeader'
import Footer from './components/Footer'
import Apoio from './components/Apoio'
import Home from './pages/Home'
import ClinicaMedica from './pages/ClinicaMedica'
import Secretariado from './pages/Secretariado'
import Cirurgiao from './pages/Cirurgiao'
import TermosDeUso from './pages/TermosDeUso'
import PoliticaPrivacidade from './pages/PoliticaPrivacidade'
import Premium from './pages/Premium'
import ConsultoriaPreCirurgica from './pages/ConsultoriaPreCirurgica'
import FormularioMedico from './pages/FormularioMedico'
import FormularioMedicoSucesso from './pages/FormularioMedicoSucesso'
import ScrollToTop from './components/ScrollToTop'
import ScrollTracker from './components/ScrollTracker'
import { useGoogleAnalytics } from './hooks/useGoogleAnalytics'
import { isConsultoriaPreCirurgicaRoute } from './lib/consultoriaRoutes'
import './App.css'

// Componente interno que usa hooks do Router
function AppContent() {
  // Inicializar Google Analytics para rastrear mudanças de rota
  useGoogleAnalytics();
  const location = useLocation()
  const isConsultoriaLanding = isConsultoriaPreCirurgicaRoute(location.pathname)

  return (
    <>
      <ScrollToTop />
      <ScrollTracker />
      <div className={isConsultoriaLanding ? 'min-h-screen bg-cream' : 'min-h-screen bg-gray-50'}>
        {isConsultoriaLanding ? <LandingHeader /> : <Header />}
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sou-clinica-medica" element={<ClinicaMedica />} />
            <Route path="/sou-secretariao" element={<Secretariado />} />
            <Route path="/sou-cirurgião" element={<Cirurgiao />} />
            <Route path="/termos-de-uso" element={<TermosDeUso />} />
            <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
            <Route path="/premium" element={<Premium />} />
            <Route path="/consultoria-pre-cirurgica/*" element={<ConsultoriaPreCirurgica />} />
            <Route path="/formulario-medico" element={<FormularioMedico />} />
            <Route path="/formulario-medico/sucesso" element={<FormularioMedicoSucesso />} />
          </Routes>
        </main>
        {!isConsultoriaLanding && <Apoio />}
        <Footer />
      </div>
    </>
  )
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  )
}

export default App

